

import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import HistoryIcon from '@material-ui/icons/History';
import UpdateIcon from '@material-ui/icons/Update';
import { Cookies } from 'react-cookie';
import {
  ORDER_PHASE_CONTACTING,
  ORDER_HISTORY,
  ORDER_FUTURE,
  ALL_ORDERS,
  ALL_ORDER_TYPES, ORDER_TYPE_DELIVERY, ORDER_TYPE_COLLECT, SUITABLE_ORDER_TYPES, ORDER_FLOW_TYPE
} from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import {
  getOrdersWithStatus,
  getOrderStatusLabel,
  getEstimationTime
} from '../../utils/orderUtils';
import { getClosedDrivers } from '../../utils/mapUtils';
import apiService from '@dishopsaas/dishop-backend-api-service';
import { showNotification } from '../../components/Notification/Notification.view';
import cancelOrderSong from '../../assets/sounds/cancelOrderSong.mp3';
import sound from '../../assets/sounds/orderSong.mp3';
import emergencyDeliverySong from '../../assets/sounds/emergencyDeliverySong.mp3';
const cookies = new Cookies();

let setIntervalTime = '';
let setIntervalSong = null;
let newOrderSound = null;
let cancelOrderSound = null;
let emergencyDeliverySound = null
let setIntervalEmergencySong = null;
let nbSong = 0;
const DUREE_MIN_SONG = 0.4;
const DURATION_INTERVAL_SONG = DUREE_MIN_SONG * 60 * 1000;

export const getOrdersShopId = (orders, shopId, isAllShops) => {
  const ordersByShopId = [];
  _.map(orders, order => {
    _.map(order, o => {
      if (isAllShops) ordersByShopId.push(o);
      else if (o.shopId === shopId) {
        ordersByShopId.push(o);
      }
    });
  });
  return ordersByShopId;
};

export const getDrivers = async (props, component) => {
  const { location = {}, independentDrivers = [], drivers: driverEmployees = [], shopId } = props;
  try {
    const closeIndependentDrivers = getClosedDrivers(independentDrivers, location);
    const closeDrivers = getClosedDrivers(driverEmployees, location);
    const drivers = closeDrivers.concat(closeIndependentDrivers);
    let nbDriversAvailable = 0;
    let nbDriversFreelance = 0;
    drivers &&
      drivers.forEach(driver => {
        const { freelance, shopIds = {}, status } = driver;
        const { enabled: enabledShop = false } = shopIds[shopId] || {};
        let enabled = enabledShop;
        if (freelance && !shopIds[shopId]) {
          enabled = true;
        }
        if (enabled && status) {
          nbDriversFreelance = freelance ? nbDriversFreelance + 1 : nbDriversFreelance;
          nbDriversAvailable = !freelance ? nbDriversAvailable + 1 : nbDriversAvailable;
        }
      });

    component.setState({ driversAvailability: { nbDriversAvailable, nbDriversFreelance } });
  } catch (error) {
    sendCloudWatchAlert(`Error in getClosedDrivers - Commandes.services: ${error}`);
  }
};
export const updateTime = component => {
  setIntervalTime = setInterval(() => {
    component.setState({
      currentDate: moment().seconds(moment().seconds() + 1)
    });
  }, 1000);
};
export const clearIntervalTime = () => {
  clearInterval(setIntervalTime);
};
export const handleLoadAudio = (component) => {
  const { orders, shopId, showModal, isAllShops } = component.props;
  const loadSound = (soundFile) => {
    const audio = new Audio(soundFile);
    audio.load();
    return audio;
  };
  newOrderSound = loadSound(sound);
  cancelOrderSound = loadSound(cancelOrderSong);
  emergencyDeliverySound = loadSound(emergencyDeliverySong);
  const currentOrdersPhaseContacting = getOrdersWithStatus(
    getOrdersShopId(orders, shopId, isAllShops),
    ORDER_PHASE_CONTACTING
  );
  if (currentOrdersPhaseContacting.length > 0) {
    clearIntervalSong();
    getOrdersSound(currentOrdersPhaseContacting);
  }
  showModal(null);
};


const play = async (sound) => {
  if (sound) {
    try {
      if (nbSong > 5) {
        clearIntervalSong();
        nbSong = 0;
      } else {
        nbSong++;
      }

      await sound.play();


    } catch (err) {
      sendCloudWatchAlert(`Error playing audio: ${err}`);
    }
  }
};

export const launchIntervalSong = (isEmergencyDelivery) => {
  try {
    const soundToPlay = isEmergencyDelivery ? emergencyDeliverySound : newOrderSound;
    soundToPlay.play();
    nbSong = 0;
    isEmergencyDelivery ? setIntervalEmergencySong = setInterval(() => play(soundToPlay), DURATION_INTERVAL_SONG) : setIntervalSong = setInterval(() => play(soundToPlay), DURATION_INTERVAL_SONG);


  } catch (error) {
    sendCloudWatchAlert(`Error in launchIntervalSong - play audio error: ${error}`);
  }
};

export const clearIntervalSong = () => {
  clearInterval(setIntervalSong);
  clearInterval(setIntervalEmergencySong);

};

export const handleCompositionOrders = async (component, nextState, props) => {
  const { orderTypeSelected, selectedToType, selectedType } = nextState;
  const type = selectedToType[orderTypeSelected];
  const { shopId, orders: pendingOrders = {}, finishedOrders, isAllShops } = props;
  const orderTypes = ALL_ORDER_TYPES;
  const selectedOrderType =
    shopId !== component.props.shopId || !orderTypes.includes(selectedType)
      ? ALL_ORDERS
      : selectedType;
  component.setState({
    isLoading: true,
    isGrid: JSON.parse(new Cookies().get('isGrid') || true),
    orderTypeSelected: shopId !== component.props.shopId ? 0 : orderTypeSelected,
    selectedType: selectedOrderType
  });
  const newOrders = getOrdersShopId(pendingOrders, shopId, isAllShops)
  setCloche(newOrders, component);
  if (type === ORDER_HISTORY) {
    if (finishedOrders) {
      const orders = getOrdersByOrderType(sortOrders(finishedOrders, type), orderTypes, props);

      component.setState({
        orders,
        viewedOrders: orders[selectedOrderType],
        isLoading: false
      });
    }
  } else {
    const orders = getOrdersByOrderType(
      sortOrders(filterOrders(pendingOrders, shopId, type === ORDER_FUTURE, isAllShops)),
      orderTypes,
      props
    );
    const oldOrders = getOrdersShopId(component.props.orders, shopId, isAllShops)
    component.setState({
      orders,
      viewedOrders: orders[selectedOrderType],
      isLoading: false
    });
    if (_.size(newOrders) < _.size(oldOrders) && selectedToType[component.state.orderTypeSelected] !== ORDER_HISTORY) {
      const missingOrders = _.filter(
        oldOrders,
        order => !_.find(newOrders, { chargeId: order.chargeId })
      )
      for (const order of missingOrders) {
        const { chargeId, id, orderNumber, orderType, totalProductPriceOrder, shop } = order;
        const canceledOrder = await apiService.canceledOrderGetOne([id, chargeId]);
        if (canceledOrder?.cancellation?.canceledBy === 'customer') {
          cancelOrderSound.play();
          const alertMessage = `La commande ${orderType === ORDER_TYPE_DELIVERY ? 'en' : orderType === ORDER_TYPE_COLLECT ? 'à' : ''} 
          <strong> ${SUITABLE_ORDER_TYPES[orderType].toLowerCase()} </strong> numéro <strong>${orderNumber}</strong> d’un montant de ${totalProductPriceOrder} € a été annulée par le client  ${isAllShops ? `pour le shop  ${shop?.name} .` : '.'}`;
          showNotification(
            'light',
            'ltr',
            'danger',
            'Commande annulée',
            alertMessage,
            '',
            'true'
          );
        }
      }
    }


  }
};

const setCloche = (orders, component) => {
  const { selectedToType = [] } = component.state;
  selectedToType.forEach(type => {
    const nextOrdersPhaseContactingByType = getOrdersWithStatus(
      orders,
      ORDER_PHASE_CONTACTING,
      type
    );
    if (nextOrdersPhaseContactingByType.length > 0) {
      component.setState({ [type]: true });
    } else {
      component.setState({ [type]: false });
    }
  });
};

const getOrdersByOrderType = (orders, types, props) => {
  const { isAllShops, shops } = props;
  const filredOrdersByShopId = isAllShops
    ? _.filter(orders, elt => _.keys(shops).includes(elt.shopId))
    : orders;
  let data = { allOrders: filredOrdersByShopId };
  types.forEach(type => {
    const filtredOrders = _.filter(filredOrdersByShopId, order => order.orderType === type);
    data = { ...data, [type]: filtredOrders };
  });
  return data;
};

export const sortOrders = (orders, type) => {
  return _.orderBy(
    orders,
    [
      order => {
        return moment(order.date);
      },
      'orderNumber'
    ],
    [type === ORDER_HISTORY ? 'desc' : 'asc', 'desc']
  );
};

export const filterOrders = (listOrders, shopid, isFutureOrder, isAllShops) => {
  const ordersFiltered = [];

  _.map(listOrders, orders => {
    _.map(orders, order => {
      const {
        shopId,
        status,
        cancellation = {},
        date,
        datePreparationStarted = moment().format()
      } = order;
      const currentDate = isFutureOrder
        ? moment().isBefore(moment(date).subtract(6, 'hours'), 'day')
        : moment().isSameOrAfter(moment(date).subtract(6, 'hours'), 'day');
      if ((shopId === shopid || isAllShops) && currentDate) {
        const { datePreparationEnded, date } = getEstimationTime(order);
        const { cancelReason } = cancellation;
        order.statusLabel = getOrderStatusLabel(status, cancelReason, status);
        ordersFiltered.push({
          ...order,
          date,
          datePreparationStarted,
          datePreparationEnded: datePreparationEnded.format(),
          limit: datePreparationEnded.diff(moment(datePreparationStarted), 'seconds')
        });
      }
    });
  });
  return ordersFiltered;
};

export const getBottomNavigationData = data => {
  const newData = [];
  _.map(data, (e, index) => {
    newData.push({
      label: e,
      icon: index === 0 ? <AccessTimeIcon /> : index === 1 ? <UpdateIcon /> : <HistoryIcon />
    });
  });
  return newData;
};
export const getBottomNavigationComponentSize = numberOfItems => {
  let classNameBottomNavigation = 'col-sm-5 col-md-5 col-lg-2';
  if (numberOfItems > 2) {
    classNameBottomNavigation = 'col-sm-12 col-md-7 col-lg-6 col-xl-4';
  }
  return classNameBottomNavigation;
};
export const onChangeData = async (e, value, rowsPerPage, component) => {
  const { shopId, isAllShops } = component.props;
  const { dateRange } = component.state;
  component.props.initPage(rowsPerPage);
  component.setState({ orderTypeSelected: value });
  if (value === 2) await component.props.getFinishedOrders(isAllShops ? null : shopId, dateRange);
};
export const handleClick = ({ order }, component) => {
  component.setState({ modalOpen: true, order });
};

export const handleClose = component => {
  component.setState({ modalOpen: false });
};
export const onChangeLayout = (value, component) => {
  cookies.set('isGrid', value);
  component.setState({ isGrid: value });
};

export const onSelectDate = (component, dateRange) => {
  const { shopId, isAllShops } = component.props;
  component.setState({ dateRange });
  component.props.getFinishedOrders(isAllShops ? null : shopId, dateRange, true);
};

export const getOrdersSound = (currentOrdersPhaseContacting) => {
  const ordersPhaseContacting = _.filter(currentOrdersPhaseContacting, order => (order.pickupStatus === 0 && (order.orderFlowType !== ORDER_FLOW_TYPE.REVERSE || order?.orderType !== ORDER_TYPE_DELIVERY)) || (order.pickupStatus === 1 && order.orderFlowType === ORDER_FLOW_TYPE.REVERSE));
  const orderPhaseSearchingDrivers = getFirstOrderPhase(currentOrdersPhaseContacting);
  if (ordersPhaseContacting.length > 0) {
    launchIntervalSong();
  }

  if (orderPhaseSearchingDrivers.length > 0) {
    launchIntervalSong(true);
  }

  else {
    clearIntervalSong();
  }
};
export const getFirstOrderPhase = (orders) => {
  return _.filter(orders, order => order.pickupStatus === 0 && order.orderFlowType === ORDER_FLOW_TYPE.REVERSE && order.selfPickupEligible && order.orderType === ORDER_TYPE_DELIVERY)
}
